import PropTypes from 'prop-types';

import { CSChatBotProvider } from '@zenbusiness/application-commons-cs-chatbot';

export function ChatBotWrapper({ children }) {
  return <CSChatBotProvider hideDefaultLauncher>{children}</CSChatBotProvider>;
}

ChatBotWrapper.propTypes = {
  children: PropTypes.node.isRequired
};
